import React, { ReactElement, useEffect, useState } from 'react';
import { Loader } from 'idsk-react-components';
import StadiumMaterialuHistoria from '../../../../model/legislativnyMaterial/StadiumMaterialuHistoria';
import SprievodnyDokumentAdd from '../../SprievodnyDokumentAdd';
import SprievodnyDokumentUpdateListTable from './SprievodnyDokumentUpdateListTable';
import useSprievodnyDokumentMergedList from '../hook/useSprievodnyDokumentMergedList';
import useSprievodnyDokumentTypList from '../../../../hooks/useSprievodnyDokumentTypList';
import LegislativnyMaterialDetailType from '../../../../model/legislativnyMaterial/LegislativnyMaterialDetail';

interface Props {
  materialDetail: LegislativnyMaterialDetailType;
  selectedStadium: StadiumMaterialuHistoria;
  setDocumentsExists: (documentsExists: boolean) => void;
}

const SprievodnyDokumentUpdateComponent = ({
  materialDetail,
  selectedStadium,
  setDocumentsExists,
}: Props): ReactElement => {
  const {
    polozkyCiselnik,
    polozkyCiselnikStatus,
  } = useSprievodnyDokumentTypList(true, false, undefined, selectedStadium.stadium.hodnota, materialDetail.typ.uuid);
  const [successMessageToDisplay, setSuccessMessageToDisplay] = useState<string>('');

  const {
    sprievodnyDokumentMergedList,
    sprievodnyDokumentMergedListStatus,
    reloadSprievodnyDokumentMergedList,
  } = useSprievodnyDokumentMergedList(
    materialDetail.uuid,
    materialDetail.typ.uuid,
    selectedStadium.uuid,
    selectedStadium.stadium.hodnota,
  );

  const documentExists = sprievodnyDokumentMergedList?.find(
    sprievodnyDokument => sprievodnyDokument.sprievodnyDokumentUuid != null,
  );

  useEffect(() => {
    if (documentExists) {
      setDocumentsExists(true);
    } else {
      setDocumentsExists(false);
    }
  }, [documentExists, setDocumentsExists, sprievodnyDokumentMergedList]);

  return (
    <>
      <Loader loading={sprievodnyDokumentMergedListStatus.loading}>
        {sprievodnyDokumentMergedList && (
          <SprievodnyDokumentUpdateListTable
            successMessageToDisplay={successMessageToDisplay}
            setSuccessMessageToDisplay={setSuccessMessageToDisplay}
            selectedStadium={selectedStadium}
            reloadSprievodnyDokumentList={reloadSprievodnyDokumentMergedList}
            sprievodnyDokumentMergedList={sprievodnyDokumentMergedList}
            materialDetail={materialDetail}
            stadiumUuid={selectedStadium.uuid}
          />
        )}
      </Loader>
      <Loader loading={polozkyCiselnikStatus.loading}>
        <SprievodnyDokumentAdd
          typDokumentuList={polozkyCiselnik}
          legMaterialUuid={materialDetail.uuid}
          stadiumUuid={selectedStadium.uuid}
          reloadSprievodnyDokumentList={reloadSprievodnyDokumentMergedList}
        />
      </Loader>
    </>
  );
};

export default SprievodnyDokumentUpdateComponent;
